export const config = {
  matterport: {
    name: 'matterport',
    enabled: false,
  },
};
